module.exports = __webpack_public_path__ + "static/media/sample-stops.33cf6f86.xlsx";